"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _urijs = _interopRequireDefault(require("urijs"));
var _ExperimentIconDiv = require("./ExperimentIconDiv");
var _evergreenUi = require("evergreen-ui");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ANNDATA_EXPERIMENT = "E-ANND";
var TITLE_COLUMN_LABEL = "Title";
var EXPERIMENT_ACCESSION_KEY = "experimentAccession";
var TableCell = function TableCell(_ref) {
  var label = _ref.label,
    dataRow = _ref.dataRow,
    dataKey = _ref.dataKey,
    image = _ref.image,
    linkTo = _ref.linkTo,
    host = _ref.host,
    width = _ref.width;
  var cellItem = null;
  var experimentAccession = dataRow[EXPERIMENT_ACCESSION_KEY];
  // If it's anndata experiment, add an icon to title column
  if (experimentAccession && experimentAccession.startsWith(ANNDATA_EXPERIMENT) && label === TITLE_COLUMN_LABEL) {
    cellItem = /*#__PURE__*/_react["default"].createElement("div", {
      className: 'icon'
    }, dataRow[dataKey], /*#__PURE__*/_react["default"].createElement("a", {
      href: "".concat(host, "/help.html?section=external-data")
    }, /*#__PURE__*/_react["default"].createElement(_ExperimentIconDiv.ExperimentIconDiv, {
      background: "indianred",
      color: "white",
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      title: "Externally analysed data"
    }, "E")));
  } else if (image) {
    // If the column is an image put the image in the cell (or an unknown icon if the type is undefined)
    cellItem = image[dataRow[dataKey]] ? /*#__PURE__*/_react["default"].createElement("img", image[dataRow[dataKey]]) : "\u2754";
  } else if (Array.isArray(dataRow[dataKey])) {
    // If the contents of the cell is an array expand it to a list
    cellItem = /*#__PURE__*/_react["default"].createElement("ul", null, dataRow[dataKey].map(function (element, index) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: "".concat(index)
      }, element);
    }));
  } else {
    // Any other type (i.e. string, number) put it as-is in the cell
    cellItem = dataRow[dataKey];
  }

  // Evergreen’s Table.TextCell ellipsifies content by default and we don’t want that
  return /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.Cell, {
    flexGrow: width
  }, /*#__PURE__*/_react["default"].createElement(_evergreenUi.Text, {
    size: 400
  }, linkTo ? /*#__PURE__*/_react["default"].createElement("a", {
    href: (0, _urijs["default"])(linkTo(dataRow), host).toString()
  }, cellItem) : cellItem));
};
TableCell.propTypes = {
  dataRow: _propTypes["default"].object.isRequired,
  dataKey: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].objectOf(_propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string,
    title: _propTypes["default"].string
  })),
  host: _propTypes["default"].string,
  linkTo: _propTypes["default"].func,
  width: _propTypes["default"].number
};
TableCell.defaultProps = {
  image: null,
  linkTo: null,
  host: "",
  width: 1
};
var _default = exports["default"] = TableCell;